import { render, staticRenderFns } from "./RestFormCat.vue?vue&type=template&id=7e2ee977&"
import script from "./RestFormCat.vue?vue&type=script&lang=js&"
export * from "./RestFormCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports